import { Link } from "react-router-dom";
import { useState } from "react";
import { FaInstagram, FaBars, FaTimes } from "react-icons/fa";
import "./NavBar.css";

import logoImage from "../assets/images/logo.jpg"; // Pfad zu deinem Logo-Bild

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <nav className="navbar">
        <Link to="/" onClick={closeMenu} className="logo-area">
          <img src={logoImage} alt="Logo" className="logo-img" />
          <div className="logo-text">
            <div className="main-title">480 Grad</div>
            <div className="subtitle">neapolitan Pizza X Pianobar</div>
          </div>
        </Link>

        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/menu" onClick={closeMenu}>
              Speisekarte
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={closeMenu}>
              <div className="texti">
                <div className="maini">Reservierung</div>
                <div className="subi">Kontakt</div>
              </div>
            </Link>
          </li>

          <li>
            <a
              href="https://www.instagram.com/480grad/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={64} />
            </a>
          </li>
        </ul>

        <button className="burger" onClick={toggleMenu}>
          {isOpen ? <FaTimes size={35} /> : <FaBars size={40} />}
        </button>
      </nav>
      {/*<div className="info-banner">
        Unsere Pizzeria bleibt bis auf Weiteres geschlossen. 🍕❤️  
        Vielen Dank für euer Verständnis und eure Unterstützung!
      </div>*/}
    </>
  );
};

export default NavBar;
